import React, {Component} from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import Helmet from "react-helmet";

import { setGuidePage } from '../../store/actions/SetGuidePage';
import SignUpForm from '../../components/SignUpForm';

import GuideDropdown from '../../components/GuideDropdown';
import GuideNav from '../../components/GuideNav';
import { ShouldIGrowMarijuana,
         OneIntro,
         Space,
         Light, 
         Water, 
         PH, 
         Temperature,
         Humidity,
         Nutrients,
         Ventilation,
         PestControl,
         AcquiringSeeds, 
         TwoIntro,
         GerminatingSeeds,
         Seedlings,
         VegetativeStage,
         DeterminingGender,
         Pruning,
         FloweringStage,
         Flushing,
         Harvesting,
         Drying,
         Curing,
         ThreeIntro,
         Cloning,
         Topping } from '../../content/guide/index';

function mapStateToProps(state) {
   return {
    selectedPage: state.guide
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setGuidePage: (page) => {
      dispatch(setGuidePage(page))
      browserHistory.push('/guide-to-gardening/' + page); 
    }
  }
}

class Guide extends Component {

  componentWillMount() {
    var page = this.props.params.page;
    this.selectGuidePage(page);
  }

  selectGuidePage(page) {
    this.props.setGuidePage(page);
    window.scrollTo(0, 0);
  }
  
  render() {
    const { selectedPage } = this.props;

    if (selectedPage === undefined) {
      return null;
    }

    let content = null;
    switch(selectedPage) {
      case 'should-i-grow-marijuana': content = ( <ShouldIGrowMarijuana /> )
        break;
      case 'part-one-introduction': content = ( <OneIntro /> )
        break;
      case 'space': content = ( <Space /> )
        break;
      case 'light': content = ( <Light /> )
        break;
      case 'water': content = ( <Water /> )
        break;
      case 'ph': content = ( <PH /> )
        break;
      case 'temperature': content = ( <Temperature /> )
        break;
      case 'humidity': content = ( <Humidity /> )
        break;
      case 'nutrients': content = ( <Nutrients /> )
        break;
      case 'ventilation': content = ( <Ventilation /> )
        break;
      case 'pest-control': content = ( <PestControl /> )
        break;
      case 'acquiring-seeds': content = ( <AcquiringSeeds /> )
        break;
      case 'part-two-introduction': content = ( <TwoIntro /> )
        break;
      case 'germinating-seeds': content = ( <GerminatingSeeds /> )
        break;
      case 'seedlings': content = ( <Seedlings /> )
        break;
      case 'vegetative-stage': content = ( <VegetativeStage /> )
        break;
      case 'determining-gender': content = ( <DeterminingGender /> )
        break;
      case 'pruning': content = ( <Pruning /> )
        break;
      case 'flowering-stage': content = ( <FloweringStage /> )
        break;
      case 'flushing': content = ( <Flushing /> )
        break;
      case 'harvesting': content = ( <Harvesting /> )
        break;
      case 'drying': content = ( <Drying /> )
        break;
      case 'curing': content = ( <Curing /> )
        break;
      case 'part-three-introduction': content = ( <ThreeIntro /> )
        break;
      case 'cloning': content = ( <Cloning /> )
        break;
      case 'topping': content = ( <Topping /> )
        break;
      default: content = ( <OneIntro /> )
        break;
    }

    return (
      <div className="Guide">
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: this.props.route.meta.meta_about },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <div className="Guide__mobile-nav">
          <h3 className="center">Jane's Guide to Gardening</h3>
          <GuideDropdown />
        </div>
        <div className="sidebar">
          <GuideNav />
        </div>
        <div className="main-content">
          {content}
          <div className="Guide__mobile-nav">
            <h3 className="center">Or Skip To Another Section</h3>
            <GuideDropdown />
          </div>
          <div className="Guide__signup">
            <h3>Join Our Mailing List</h3>
            <p>Keep up to date with all the latest information on legal marijuana and home cultivation in the United States.</p>
            <SignUpForm />
          </div>
        </div>
      </div>
    )
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Guide);




// WEBPACK FOOTER //
// ./src/views/Guide/Guide.js